import React from "react";
import { BarLoader } from "react-spinners";

export default function() {
  const {
    nearbyStores,
    formattedAddress,
    locationServicesEnabled,
    collapsed,
    loading
  } = this.state;
  return (
    <div className="form">
      <button
        onClick={() => this.setState({ collapsed: !this.state.collapsed })}
      >
        {loading ? (
          <div className="button-loader">
            <BarLoader width={200} height={4} color={"white"} />
          </div>
        ) : (
          `Stores near ${formattedAddress}`
        )}
      </button>
      {locationServicesEnabled ? (
        collapsed ? null : nearbyStores.length > 0 ? (
          nearbyStores.map((store, index) => this._renderStore(store, index))
        ) : (
          <div className="list-item">No nearby stores</div>
        )
      ) : null}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/stores/nearby-stores/view.js